import BoardPackPanel from "@/components/risk/BoardPackPanel";
export default function RBoard() { return <BoardPackPanel range="R" />; }
